import { render, staticRenderFns } from "./ShippingCostsDialog.vue?vue&type=template&id=10b52446"
import script from "./ShippingCostsDialog.vue?vue&type=script&lang=js"
export * from "./ShippingCostsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports